import { render, staticRenderFns } from "./VerticalHeader.vue?vue&type=template&id=7294e8d6&"
import script from "./VerticalHeader.vue?vue&type=script&lang=js&"
export * from "./VerticalHeader.vue?vue&type=script&lang=js&"
import style0 from "./VerticalHeader.vue?vue&type=style&index=0&id=7294e8d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports